import React, { useState, useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const useHoverToggler = (toggle) => {
    const isTouchTap = useRef(true);

    const handleTouchStart = useCallback(() => {
        isTouchTap.current = true;
    }, []);

    const handleTouchCancel = useCallback(() => {
        isTouchTap.current = false;
    }, []);

    const handleTouchMove = useCallback(() => {
        isTouchTap.current = false;
    }, []);

    const handleTouchEnd = useCallback(
        () => {
            toggle(isTouchTap.current);
            isTouchTap.current = false;
        },
        [toggle]
    );

    return {
        onMouseEnter: () => toggle(true),
        onMouseLeave: () => toggle(false),
        onTouchStart: handleTouchStart,
        onTouchCancel: handleTouchCancel,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
    };
};

const Hover = ({ children, onHover, DropElement, show, ...props }) => {
    const [showDrop, toggleShow] = useState(null);

    const toggle = useCallback((show) => {
        toggleShow(show);
    }, []);

    const onExternalClose = useCallback((show) => {
        toggleShow(show);
    }, []);

    const childrenProps = useHoverToggler(toggle);

    useEffect(
        () => {
            if (showDrop !== null) {
                onHover && onHover(showDrop);
            }
        },
        [showDrop, onHover]
    );

    if (!children) {
        return null;
    }

    const wrappedChildren = typeof children === 'string' ? <span>{children}</span> : children;

    return (
        <DropElement {...props} onExternalClose={onExternalClose} show={showDrop === null ? show : showDrop}>
            {React.cloneElement(wrappedChildren, childrenProps)}
        </DropElement>
    );
};

Hover.propTypes = {
    /** Любой компонент Drop */
    DropElement: PropTypes.func,
    /** Колбек onHover DropElement, аргументом передаётся флаг показан или скрыт компонент  */
    onHover: PropTypes.func,
    /** Элемент инициатор, относительно которого показывать DropElement */
    children: PropTypes.node,
};

export default Hover;
